import { React } from "react";
import { Route } from "react-router-dom";
import DashboardContent from "./DashboardContent/DashboardContent";
import MatchingContent from "./MatchingContent/MatchingContent";
import AccountContent from "./AccountContent/AccountContent";
import AccountIcon from "../DashboardNav/Icons/AccountIcon";
import "./Tab.css";

const Tab = (props) => {
  return (
    <div className={props.menuIsOpen ? "tab tab-menu-open" : "tab"}>
      <div className="tab-user">
        <div className="tab-user-name body-text">
          <AccountIcon /> {props.userName + "  " + props.userLastName}
        </div>
      </div>
      <Route
        path={props.match.url + "/"}
        render={() => <DashboardContent userName={props.userName} />}
        exact
      />

      <Route
        path={props.match.url + "/matching-criteria"}
        render={() => (
          <MatchingContent
            showSuccessBox={props.showSuccessBox}
            showErrorBox={props.showErrorBox}
          />
        )}
        exact
      />

      <Route
        path={props.match.url + "/account"}
        render={() => (
          <AccountContent
            showSuccessBox={props.showSuccessBox}
            showErrorBox={props.showErrorBox}
            handleNameUpdate={props.handleNameUpdate}
            handleLastNameUpdate={props.handleLastNameUpdate}
          />
        )}
        exact
      />
    </div>
  );
};

export default Tab;
